import { consultasTxt } from "@/lib/migracion";

const Tile = ({ label, value, testid, fuerte }) => (
  <div className="rounded-md border border-slate-200 bg-white px-3 py-2" data-testid={testid}>
    <p className="text-[11px] uppercase tracking-wide text-slate-400">{label}</p>
    <p className={`mt-0.5 font-mono text-lg tabular-nums ${fuerte ? "font-semibold text-slate-900" : "text-slate-700"}`}>{value}</p>
  </div>
);

export function ResumenLote({ lote }) {
  const disp = lote.consultas_disponibles_ahora ?? lote.consultas_disponibles;
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4 lg:grid-cols-8" data-testid="migracion-resumen">
      <Tile label="Total" value={lote.total_filas} testid="migracion-resumen-total" />
      <Tile label="Nuevos" value={lote.filas_nuevas} testid="migracion-resumen-nuevos" fuerte />
      <Tile label="Vinculados (ya existían)" value={lote.filas_vinculadas} testid="migracion-resumen-vinculados" fuerte />
      <Tile label="Omitidos" value={lote.filas_omitidas} testid="migracion-resumen-omitidos" />
      <Tile label="Con error" value={lote.filas_error} testid="migracion-resumen-errores" />
      <Tile label="Con advertencia" value={lote.advertencias ?? 0} testid="migracion-resumen-advertencias" />
      <Tile label="Consultas que consumirá" value={lote.consultas_a_consumir} testid="migracion-resumen-consumira" fuerte />
      <Tile label="Consultas disponibles" value={consultasTxt(disp)} testid="migracion-resumen-disponibles" />
    </div>
  );
}
